import React, { useState } from 'react';
import { Button, Input, Modal } from 'rsuite';

import { LevelsType } from '../lib';
import styles from './ModalCategoryLevels.module.scss';

const { Header, Body, Footer } = Modal;

interface ModalCategoryLevelsProps {
  open: boolean;
  onChange: (event: LevelsType) => void;
  value: LevelsType;
  onClose: () => void;
}

export const ModalCategoryLevels = ({ open, onChange, value, onClose }: ModalCategoryLevelsProps) => {
  const [newValue, setNewValue] = useState(value?.name);

  const handleCancel = () => {
    onClose();
  };

  const handleSave = () => {
    onChange({ ...value, name: newValue, label: value.level + ' - ' + newValue });
    onClose();
  };
  return (
    <Modal show={open} onHide={() => onClose()} keyboard className={styles.container}>
      <Header className={styles.header}>
        <span>Editar Nível</span>
      </Header>
      <Body className={styles.body}>
        <label htmlFor="name" className={styles['input-label']}>
          Defina como você quer chamar o nível de categoria escolhido
        </label>
        <Input id="name" autoFocus className={styles['input-name']} type="text" onChange={v => setNewValue(v)} value={newValue} />
      </Body>
      <Footer className={styles.footer}>
        <div>
          <Button appearance="ghost" onClick={handleCancel}>
            Cancelar
          </Button>
          <Button appearance="primary" onClick={handleSave}>
            Salvar
          </Button>
        </div>
      </Footer>
    </Modal>
  );
};
